import { useCallback, useEffect, useState } from "react"
import actionsService, { WfmAbsence } from "../../../../services/actionsService"
import { useAppDispatch } from "../../../../redux/store"
import { showErrorMessage } from "../../../../redux/reducers/snackbarReducer"
import { hideDrawer } from "../../../../redux/reducers/appSettingsReducer"

export const tryAgainLater = "Please contact BSS if the issue persists."
const errorUnlocking = "Something went wrong while unlocking the WFM absence."

const useWfmAbsence = (wfmAbsenceId?: number) => {
  const dispatch = useAppDispatch()
  const [wfmAbsence, setWfmAbsence] = useState<WfmAbsence>()

  useEffect(() => {
    if (!wfmAbsenceId) {
      return
    }

    actionsService.wfm
      .getWfmAbsenceById(wfmAbsenceId)
      .then(response => {
        setWfmAbsence(response)
      })
      .catch(err => {
        const msg = `Wfm Absence with ID: ${wfmAbsenceId} could not be retrieved. ${tryAgainLater}`
        dispatch(hideDrawer())
        dispatch(showErrorMessage(msg))
      })
  }, [dispatch, wfmAbsenceId])

  const unlockWfmAbsence = useCallback(() => {
    if (!wfmAbsenceId) {
      return
    }
    
    actionsService.wfm
      .unlockWfmAbsencePlaceholder(wfmAbsenceId)
      .then(response => {
        if (!response.result) {
          dispatch(showErrorMessage(errorUnlocking))
        }
      })
      .catch(err => {
        dispatch(showErrorMessage(errorUnlocking))
      })
  }, [wfmAbsenceId])

  return {
    wfmAbsence,
    unlockWfmAbsence,
  }
}

export default useWfmAbsence